import React from 'react';
import FormInput from "../../common/form/form_input";
import FormPassword from "../../common/form/form_password";
import {Link} from "react-router-dom";
import FormErrorMessage from "../../common/form/form_error_message";
import GoogleAuthenticatorComponent from "../../../js/app/sign_up/app/component/2fa/google_authenticator";
import InfoCardClusterLogin from "../../main/component/info-cards/info-card--cluster-login";
import {_t} from "../../../js/app/common/utils/locale";
import FormLogin from "../../common/form/form_login";
import Visible from "../../../js/app/main/app/component/common/visible";

export default function render(props) {
    if (this.state.second_factor_mode) {
        if (this.state.provider === 'ga') {
            return (
                <div>
                    <GoogleAuthenticatorComponent
                        onSuccess={this.onSave.bind(this)}
                        cluster={this.state.cluster}
                    />
                </div>
            );
        }
        return (
            <div>{_t('Unknown 2FA provider')}</div>
        );
    }

    return (
        <section className="section section-cluster-form section-cluster-login">
            <section className="cluster-form-card login-card login-card__login">

                <InfoCardClusterLogin />

                <div className="cluster-form-card__body login-card__form">
                    <header className="cluster-form-card__header">
                        <h2 className="title title--h2">{_t('Cluster Login')}</h2>
                    </header>

                    <FormErrorMessage message={this.state.error_message} />

                    <Visible visible={!this.props.cluster}>
                        <FormInput
                            name={'cluster'}
                            label={'Cluster login'}
                            onChange={this.onChangeInput.bind(this)}
                            errors={this.state.errors.cluster}
                            labelClass="cluster-login"
                        />
                    </Visible>
                    <FormInput
                        name={'login'}
                        label={'User login'}
                        onChange={this.onChangeInput.bind(this)}
                        errors={this.state.errors.login}
                        labelClass="user-login"
                    />
                    <FormPassword
                        name={'password'}
                        label={'Password'}
                        onChange={this.onChangeInput.bind(this)}
                        errors={this.state.errors.password}
                        labelClass="password"
                    />

                    <div className={'cluster__form-group'}>
                        <Link to="/reset-password" className="link link--primary btn__reg float-right">{_t('Reset password')}</Link>
                    </div>

                    <div className="btn-bar">
                        <button className="btn btn--alt btn__login" onClick={this.onSubmit.bind(this)}>{_t('Login')}</button>
                        <Link to="/sign-up" className="link link--primary link--bold btn__reg">{_t('Sign up')}</Link>
                    </div>
                </div>


            </section>
        </section>
    );
};